import { defineQuartzConfig } from 'quartz-core/config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: '/embedded-viral-link',
  htmlTitle: 'Embedded Viral Link UI',
  logFetchErrors: {
    options: {
      ignoreErrors: [/Loading chunk/, /I18n: Missing translation/, /timeout/i, /TrackerStorageType is not defined/, /.*dlb\/bundle\.production\.js not loaded$/],
      ignoreUrls: [/^(?!.*embedded-viral-link).*$/]
    }
  },
  htmlTitleLangKey: 'app.htmlTitle'
});